import styled from 'styled-components';

export const AnswerWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;
export const AnswerTextWrapper = styled.div<{ $isTrueFalse: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isTrueFalse }) => ($isTrueFalse ? 'center' : 'flex-start')};
  width: 100%;
  gap: 4px;
  font-size: ${({ $isTrueFalse }) => ($isTrueFalse ? '16px' : '14px')};
  line-height: ${({ $isTrueFalse }) => ($isTrueFalse ? '24px' : '20px')};
  font-weight: ${({ $isTrueFalse }) => ($isTrueFalse ? '500' : '400')};

  & > p {
    margin: 0 !important;
  }

  .ant-image {
    width: fit-content;
  }
`;

export const FormulaWrapper = styled.div`
  display: flex;
`;

export const StyledImage = styled.img`
  width: fit-content;
  max-width: 100%;
`;
